/* global process */
let base = window._env_.VUE_APP_FIN_CENTER_HOST

export const getCustomerProjectReportTable = params => {
  return axios.post(`${base}/receipt-applications/query_project_report`, params)
}



// WEBPACK FOOTER //
// ./src/views/customer-project-report/customer-project-report.api.js